import type { StreamStepEvent } from "~/services/aiOrchestrator";

export type StreamStepStatus = "active" | "error" | "success";

export interface StreamStep {
	label: string;
	status: StreamStepStatus;
	toolName: string;
}

const resolveStatus = (event: StreamStepEvent): StreamStepStatus => {
	if (event.phase !== "completed") return "active";
	return event.status === "error" ? "error" : "success";
};

const mergeStreamStep = (steps: StreamStep[], event: StreamStepEvent): StreamStep[] => {
	const next: StreamStep = { label: event.label, status: resolveStatus(event), toolName: event.toolName };
	const index = steps.findIndex((step) => step.toolName === event.toolName && step.status === "active");
	if (index === -1) return [...steps, next];
	const merged = steps.slice();
	merged[index] = next;
	return merged;
};

export default mergeStreamStep;

export { mergeStreamStep };
